import React, {lazy} from "react";
const PaymentIconUI = lazy(() => import("react-payment-icons-inline"));

function PaymentIcon({cardType, style, ...props}) {
  return <PaymentIconUI key={cardType} icon={cardType} style={style} {...props} />;
}

export default PaymentIcon;
